import { useTranslation } from 'react-i18next';
import {
  ModalOverlay,
  PhoneCallIcon,
  Loader,
  SentaraLogo
} from '@sentara-health/optimahealth_web';
import { VirtualVisitModalBox } from 'templates'; 
import { SERVICE_PHONE_NUMBER, NURSE_ADVICE_LINE_MEDICAID_OR_DSNP_PHONE_NUMBER } from 'common';
import { GlobalContext } from 'context';
import { useContext } from 'react';
import { useVirtualPopUpHooks } from './hooks/VirtualPopUpHooks';

interface NurseOnCallPopUpProps {
  closeModal: () => void;
}
function NurseOnCallPopUp({
    closeModal
}: Readonly<NurseOnCallPopUpProps>) {
    // Initialize translation hook
    const { t } = useTranslation();

    const { getFeature } = useContext(GlobalContext);

    const isMedicaidOrDsnpMember =
    !!getFeature?.HomeAddressMedicaid || !!getFeature?.HomeAddressDSNP;

    const nurseLinePhoneNumber = isMedicaidOrDsnpMember
      ? NURSE_ADVICE_LINE_MEDICAID_OR_DSNP_PHONE_NUMBER
      : SERVICE_PHONE_NUMBER;

    const nurseLineButtonText = isMedicaidOrDsnpMember
      ? t('virtualVisitCare.NurseOnCall.sentaraContent.buttonTextMedicaidOrDsnp')
      : t('virtualVisitCare.NurseOnCall.sentaraContent.buttonText');

    const sentaraDisclaimerList = [
      {text:t('virtualVisitCare.NurseOnCall.sentaraContent.disclaimerNote1') , style:'mt-3'},
      {text:t('virtualVisitCare.NurseOnCall.sentaraContent.disclaimerNote2') , style:'mt-2'},
    ]

    const nurseOnCallPopUpHooks = useVirtualPopUpHooks();


    return (
      <>
        <ModalOverlay
          className="virtual-visit-box"
          data-testid={'virtualVisitSelectionId'}
          isOpen
          onClose={closeModal}
          overlayInfo="virtual visit selection"
        >
            <div className="curved-box-single-box gap-4 w-100">
              <VirtualVisitModalBox
                logoImage={<SentaraLogo/>}
                title={t(
                  'virtualVisitCare.sentaraHealthTitle'
                )}
                subtitle={t('virtualVisitCare.NurseOnCall.sentaraContent.nurseOnCall')!}
                badgeImage={<PhoneCallIcon/>}
                content={t(
                  'virtualVisitCare.NurseOnCall.sentaraContent.nurseOnCallContent'
                )}
                buttonLabel={nurseLineButtonText}
                 buttonTestId='sentaraCallButton'
                buttonOnClick={() => {
                  nurseOnCallPopUpHooks.PhoneNumberLink({ phoneNumber: nurseLinePhoneNumber });
                }}
                displayBlock={true}
                minHeight={'200'}
                disclaimers={sentaraDisclaimerList}
              />
            </div>
        </ModalOverlay>
        {nurseOnCallPopUpHooks?.loading ? <Loader /> : null}
      </>
    );
  }
  
export default NurseOnCallPopUp;